

const CATEGORY_ITEMS = [
  { slug: 'aisan', label: 'Aisan' },
  { slug: 'carburetor_electric_choke', label: 'Carburetor Electric Choke' },
  { slug: 'carter_afb_marine', label: 'Carter AFB Marine' },
  { slug: 'carter_afb_marine_carburetor', label: 'Carter AFB Marine Carburetor' },
  { slug: 'carter_bbd_carburetor', label: 'Carter BBD Carburetor' },
  { slug: 'carter_bbd_carburetor_jeep', label: 'Carter BBD Carburetor Jeep' },
  { slug: 'carter_marine_carburetor', label: 'Carter Marine Carburetor' },
  { slug: 'carter_weber_marine_carburetors', label: 'Carter Weber Marine Carburetors' },
  { slug: 'holley_four_barrel_4160', label: 'Holley Four Barrel 4160' },
  { slug: 'holley_marine_carburetor_two_barrel', label: 'Holley Marine Carburetor Two Barrel' },
  { slug: 'hotrod', label: 'Hot Rod' },
  { slug: 'jeep_carburetor', label: 'Jeep Carburetor' },
  { slug: 'marine', label: 'Marine' },
  { slug: 'penta_marine', label: 'Penta Marine' },
  { slug: 'quadrajet_volvo', label: 'Quadrajet Volvo' },
  { slug: 'ratrod', label: 'Rat Rod' },
  { slug: 'rochester_b_model_hand_choke_carburetor', label: 'Rochester B Model Hand Choke Carburetor' },
  { slug: 'rochester_four_4_barrel_carburetor_e4me', label: 'Rochester Four 4 Barrel Carburetor E4ME' },
  { slug: 'rochester_four_barrel_careburetor_marine_omc', label: 'Rochester Four Barrel Carburetor Marine OMC' },
  { slug: 'rochester_marine_carburetors_twin_set_up', label: 'Rochester Marine Carburetors Twin Set Up' },
  { slug: 'rochester_marine_quadrajet', label: 'Rochester Marine Quadrajet' },
  { slug: 'rochester_marine_quadrajet_carburetor', label: 'Rochester Marine Quadrajet Carburetor' },
  { slug: 'rochester_marine_quadrajet_carburetor_volvo_penta', label: 'Rochester Marine Quadrajet Carburetor Volvo Penta' },
  { slug: 'rochester_marine_two_barrel_carburetor_elec_choke_at_the_base', label: 'Rochester Marine Two Barrel Carburetor Electric Choke At The Base' },
  { slug: 'rochester_performance_quadrajet_carburetor', label: 'Rochester Performance Quadrajet Carburetor' },
  { slug: 'rochester_quadrajet_marine_carburetors', label: 'Rochester Quadrajet Marine Carburetors' },
  { slug: 'rochester_two_barrel', label: 'Rochester Two Barrel' },
  { slug: 'rochester_two_barrel_marine_carburetor', label: 'Rochester Two Barrel Marine Carburetor' },
  { slug: 'rochester_verajet_jeep_carburetor_2.8', label: 'Rochester Verajet Jeep Carburetor 2.8' },
  { slug: 'stromberg97', label: 'Stromberg 97' },
  { slug: 'stromberg', label: 'Stromberg' },
  { slug: 'toyota', label: 'Toyota' },
  { slug: 'two_barrel_rochester_marine_2gc_rebuild_kit', label: 'Two Barrel Rochester Marine 2GC Rebuild Kit' },
];

function SideBar({
  isOpen = false,
  navItems = [],
  currentPath = '/',
  onNavigate = () => {},
  onClose = () => {},
}) {
  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  const handleCategoryNavigate = (slug) => {
    onNavigate('/products');

    window.setTimeout(() => {
      window.location.hash = slug;
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    }, 60);
  };

  return (
    <div
      aria-hidden={!isOpen}
      onClick={handleBackdropClick}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1450,
        display: 'flex',
        justifyContent: 'flex-end',
        background: isOpen ? 'rgba(5, 10, 18, 0.56)' : 'rgba(5, 10, 18, 0)',
        backdropFilter: isOpen ? 'blur(10px)' : 'blur(0px)',
        WebkitBackdropFilter: isOpen ? 'blur(10px)' : 'blur(0px)',
        pointerEvents: isOpen ? 'auto' : 'none',
        opacity: isOpen ? 1 : 0,
        transition: 'opacity 260ms ease, background 260ms ease, backdrop-filter 260ms ease',
      }}
    >
      <aside
        role="dialog"
        aria-modal="true"
        aria-label="Quick tools and categories"
        style={{
          width: typeof window !== 'undefined' && window.innerWidth >= 1024 ? '420px' : '92vw',
          maxWidth: '460px',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          background:
            'radial-gradient(circle at top right, rgba(79,163,255,0.16), transparent 28%), linear-gradient(180deg, rgba(12,17,26,0.99) 0%, rgba(17,24,36,0.99) 100%)',
          borderLeft: '1px solid rgba(255,255,255,0.08)',
          boxShadow: '-20px 0 60px rgba(0,0,0,0.42)',
          transform: isOpen ? 'translateX(0)' : 'translateX(106%)',
          transition: 'transform 320ms cubic-bezier(0.22, 1, 0.36, 1)',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '-70px',
            right: '-40px',
            width: '180px',
            height: '180px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(79,163,255,0.18), transparent 68%)',
            pointerEvents: 'none',
          }}
        />

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px',
            padding: '18px 18px 14px',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
            background: 'linear-gradient(180deg, rgba(255,255,255,0.04), rgba(255,255,255,0))',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <span style={{ fontSize: '1.06rem', fontWeight: 800, letterSpacing: '0.02em', color: '#ffffff' }}>
              Quick Tools
            </span>
            <span style={{ marginTop: '2px', fontSize: '0.76rem', color: 'rgba(255,255,255,0.68)' }}>
              Search, categories, and product shortcuts
            </span>
          </div>

          <button
            type="button"
            onClick={onClose}
            aria-label="Close sidebar"
            style={{
              minWidth: '44px',
              minHeight: '44px',
              border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: '12px',
              cursor: 'pointer',
              background: 'rgba(255,255,255,0.08)',
              color: '#ffffff',
              fontSize: '1.12rem',
              fontWeight: 700,
              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)',
            }}
          >
            ✕
          </button>
        </div>

        <div
          style={{
            padding: '16px 14px 18px',
            display: 'flex',
            flexDirection: 'column',
            gap: '14px',
            overflowY: 'auto',
            flex: 1,
            position: 'relative',
            zIndex: 1,
          }}
        >
          <div
            style={{
              padding: '16px',
              borderRadius: '18px',
              background: 'linear-gradient(180deg, rgba(255,255,255,0.055), rgba(255,255,255,0.025))',
              border: '1px solid rgba(255,255,255,0.08)',
              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.03)',
            }}
          >
            <div style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.62)', marginBottom: '6px' }}>
              Fast access
            </div>
            <div style={{ fontSize: '1rem', fontWeight: 800, color: '#ffffff', marginBottom: '8px' }}>
              Navigate the store quicker
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              {navItems.map((item) => {
                const isActive = currentPath === item.path;

                return (
                  <button
                    key={item.path}
                    type="button"
                    onClick={() => {
                      onNavigate(item.path);
                      onClose();
                    }}
                    aria-current={isActive ? 'page' : undefined}
                    style={{
                      minHeight: '48px',
                      borderRadius: '14px',
                      border: isActive
                        ? '1px solid rgba(79,163,255,0.34)'
                        : '1px solid rgba(255,255,255,0.08)',
                      background: isActive
                        ? 'linear-gradient(135deg, rgba(79,163,255,0.18), rgba(31,111,235,0.14))'
                        : 'rgba(255,255,255,0.05)',
                      color: '#ffffff',
                      fontWeight: isActive ? 800 : 700,
                      fontSize: '0.88rem',
                    }}
                  >
                    {item.label}
                  </button>
                );
              })}
            </div>
          </div>

          <div
            style={{
              padding: '16px',
              borderRadius: '18px',
              background: 'linear-gradient(180deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))',
              border: '1px solid rgba(255,255,255,0.08)',
            }}
          >
            <div style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.62)', marginBottom: '6px' }}>
              Categories
            </div>
            <div style={{ fontSize: '1rem', fontWeight: 800, color: '#ffffff', marginBottom: '8px' }}>
              Browse product families
            </div>
            <div style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.76)', marginBottom: '14px' }}>
              These buttons will connect to dedicated ProductCard sections inside your Products page.
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '52vh', overflowY: 'auto', paddingRight: '4px' }}>
              {CATEGORY_ITEMS.map((category, index) => {
                const isSelected = window.location.pathname === '/products' && window.location.hash === `#${category.slug}`;

                return (
                  <button
                    key={category.slug}
                    type="button"
                    onClick={() => {
                      handleCategoryNavigate(category.slug);
                      onClose();
                    }}
                    style={{
                      width: '100%',
                      minHeight: '54px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '12px',
                      padding: '14px 16px',
                      border: isSelected
                        ? '1px solid rgba(79,163,255,0.34)'
                        : '1px solid rgba(255,255,255,0.08)',
                      borderRadius: '14px',
                      background: isSelected
                        ? 'linear-gradient(135deg, rgba(79,163,255,0.18), rgba(31,111,235,0.14))'
                        : 'rgba(255,255,255,0.04)',
                      color: '#ffffff',
                      fontSize: '0.94rem',
                      fontWeight: isSelected ? 800 : 600,
                      textAlign: 'left',
                      cursor: 'pointer',
                      opacity: 0.98,
                      animation: `sidebarFadeIn 420ms ease ${index * 24}ms both`,
                    }}
                  >
                    <span style={{ flex: 1 }}>{category.label}</span>
                    <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '1rem' }}>›</span>
                  </button>
                );
              })}
            </div>
          </div>

          <div
            style={{
              padding: '16px',
              borderRadius: '18px',
              background: 'linear-gradient(180deg, rgba(255,255,255,0.055), rgba(255,255,255,0.025))',
              border: '1px solid rgba(255,255,255,0.08)',
              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.03)',
            }}
          >
            <div style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.62)', marginBottom: '6px' }}>
              Need help matching a part?
            </div>
            <div style={{ fontSize: '1rem', fontWeight: 800, color: '#ffffff', marginBottom: '8px' }}>
              Jump to Carb Finder
            </div>
            <div style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.76)', marginBottom: '14px' }}>
              Use the finder when the category is close but you still need help confirming fitment.
            </div>
            <button
              type="button"
              onClick={() => {
                onNavigate('/carb-finder');
                onClose();
              }}
              style={{
                width: '100%',
                minHeight: '50px',
                borderRadius: '14px',
                background: 'linear-gradient(135deg, #1f6feb, #4fa3ff)',
                color: '#ffffff',
                fontWeight: 800,
                boxShadow: '0 12px 28px rgba(31,111,235,0.28)',
              }}
            >
              Open Carb Finder
            </button>
          </div>
        </div>
      </aside>

      <style>
        {`
          @keyframes sidebarFadeIn {
            from {
              opacity: 0;
              transform: translateX(10px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
        `}
      </style>
    </div>
  );
}

export default SideBar;